import type { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';

import type { LcpnTheme } from '../../styles/theme';
import { countryStatusConfig } from '../../map-data/heatmap-legend-config';
import { Typography } from '../Typography';

import { KeyColor } from './KeyColor';

// Only show these statuses in the Status view legend
const STATUS_LEGEND_VISIBLE = new Set([
  'Formal commitment',
  'Implementation roll-out',
]);

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  legend: {
    position: 'absolute',
    bottom: 38,
    right: 8,
    background: 'rgba(255, 255, 255, 0.85)',
    borderRadius: 12.5,
    minWidth: 250,
    padding: theme.spacing(3),
  },

  values: {
    display: 'flex',
    flexDirection: 'column',
  },

  item: {
    display: 'flex',
    gap: theme.spacing(2),
    fontSize: theme.fontSizes.p2,
    alignItems: 'center',
  },

  note: {
    textAlign: 'center',
    paddingTop: theme.spacing(2),
    width: '100%',
    maxWidth: '14em',
    margin: '0 auto',
  },
}));

export const StatusLegend: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.legend}>
      <div className={classes.values}>
        {countryStatusConfig
          .filter(s => STATUS_LEGEND_VISIBLE.has(s.dataValue))
          .map((item, index) => (
            <div key={index} className={classes.item}>
              <KeyColor color={item.color} />
              <span>{t(`countryStatus.${item.translationKey}`)}</span>
            </div>
          ))}
      </div>
      <div className={classes.note}>
        <Typography variant="p3">{t('statusLegend.note')}</Typography>
      </div>
    </div>
  );
};
